import React, { createContext, useContext, useState } from 'react';

const UIContext = createContext(null);

export function useUI() {
    return useContext(UIContext);
}

function persisted(key, fallback) {
    try {
        const v = localStorage.getItem('mb:' + key);
        if (v === null) return fallback;
        return JSON.parse(v);
    } catch {
        return fallback;
    }
}

function persist(key, v) {
    try {
        localStorage.setItem('mb:' + key, JSON.stringify(v));
    } catch {}
}

export function UIProvider({ children }) {
    const [theme, setThemeState] = useState(() => persisted('theme', 'light'));
    const [bookLayout, setBookLayoutState] = useState(() => {
        const v = persisted('bookLayout', 'shelf');
        return v === 'timeline' ? 'shelf' : v; // migrate legacy value
    });
    const [signedIn, setSignedInState] = useState(false);

    const setTheme = (t) => {
        setThemeState(t);
        persist('theme', t);
    };

    const setBookLayout = (l) => {
        setBookLayoutState(l);
        persist('bookLayout', l);
    };

    const setSignedIn = (v) => {
        setSignedInState(v);
    };

    const value = {
        theme,
        setTheme,
        bookLayout,
        setBookLayout,
        signedIn,
        setSignedIn,
    };

    return <UIContext.Provider value={value}>{children}</UIContext.Provider>;
}
